import { Duration } from 'luxon';

export class TimeSpan {

    /**
     * Function, that converts String to TimeSpan
     * @param strValue Input string value
     * @returns {TimeSpan} Value as TimeSpan
     */
    public static fromDto(strValue: string): TimeSpan {
        const matchResult = /(?:(\d+)\.)?(\d{1,2}):(\d{1,2}):(\d{1,2})/.exec(strValue);
        if (!matchResult || matchResult.length !== 5) {
            throw new Error(`Invalid TimeSpan value '${strValue}'`);
        } else {
            let days;
            if (matchResult[1]) {
                days = parseInt(matchResult[1], 10);
            } else {
                days = undefined;
            }

            const hours = parseInt(matchResult[2], 10);
            const minutes = parseInt(matchResult[3], 10);
            const seconds = parseInt(matchResult[4], 10);

            if (hours < 0 || 23 < hours
                || minutes < 0 || 59 < minutes
                || seconds < 0 || 59 < seconds) {
                throw new Error();
            }

            const duration = Duration.fromObject({
                days,
                hours,
                minutes,
                seconds,
            });

            const result = new TimeSpan(duration);

            return result;
        }
    }

    /**
     * Fumction to compare Strings as TimeSpans
     * @param value1 Value 1 to compare
     * @param value2 Value 2 to compare
     * @returns -1 - (Value1 < Value2); 0 - equal; 1 - (Value1 > Value2).
     */
    public static compareStr(value1: string, value2: string): number {
        const valueTimeSpan1: TimeSpan = this.fromDto(value1);
        const valueTimeSpan2: TimeSpan = this.fromDto(value2);
        return this.compare(valueTimeSpan1, valueTimeSpan2);
    }

    /**
     * Fumction to compare TimeSpans
     * @param value1 Value 1 to compare
     * @param value2 Value 2 to compare
     * @returns -1 - (Value1 < Value2); 0 - equal; 1 - (Value1 > Value2).
     */
    public static compare(value1: TimeSpan, value2: TimeSpan): number {
        const valueSec1: number = this.toSecs(value1);
        const valueSec2: number = this.toSecs(value2);
        return valueSec1 === valueSec2 ? 0 :
               valueSec1 > valueSec2 ? 1 : -1;
    }

    /**
     * Function to convert TimeSpan to seconds
     * @param duration Value as Duration
     */
    public static toSecs(value: TimeSpan): number {
        return this.durationToSecs(value.duration);
    }

    /**
     * Function to convert Duration to seconds
     * @param duration Value as Duration
     */
    public static durationToSecs(value: Duration): number {
        let result: number = 0;
        result = value.days * 86400;
        result += value.hours * 3600;
        result += value.minutes * 60;
        result += value.seconds;

        return result;
    }

    private readonly _duration: Duration;

    constructor(duration: Duration) {
        this._duration = duration;
    }

    /**
     * @returns TimeSpan value as Duration
     */
    public get duration(): Duration {
        return this._duration;
    }

    /**
     *  @returns Timespan value as amount of seconds
     */
    public toSecs(): number {
        let result: number = 0;
        result = this._duration.days * 86400;
        result += this._duration.hours * 3600;
        result += this._duration.minutes * 60;
        result += this._duration.seconds;

        return result;
    }

    /**
     *  @returns TimeSpan value as String
     */
    public toDto(): string {
        const result = this._duration.toFormat('dd.hh:mm:ss');
        return result;
    }

}
